import React from "react"
import "./unitTypeWithPrice.scss"
import Button from "@paprika/button"

export default function UnitContentWithPricing({
  numOfAvailableMarkersByType,
  item,
  isPricingShowing,
  shouldAllPitchesShowRemaining,
  onBookNow,
  isPitchBookingLimited,
}) {
  const pricingData = item.pricingData && item.pricingData[0]
  const numOfMarkers = numOfAvailableMarkersByType[item.name]
  const itemNameAsArray = item.name.split(/-(.*)/s)

  const bookByType = () => {
    onBookNow(item)
  }

  const renderPitchNumbersCount = () => {
    if (shouldAllPitchesShowRemaining || numOfMarkers < 10) {
      return <div className="num-of-markers">Only {numOfMarkers} left</div>
    }
    if (isPitchBookingLimited) {
      return <div className="num-of-markers">{numOfMarkers} left</div>
    }
    return null
  }

  return (
    <div className="filter-option">
      <div className="filter-option-name">
        <div>{itemNameAsArray[0]} -</div>
        <div>{itemNameAsArray[1]}</div>
      </div>
      <div>
        {pricingData && isPricingShowing ? (
          <div className="filter-option-price">
            {pricingData.discount && Number(pricingData.discount) > 0 ? (
              <div className="non-discount-price">£{Number(pricingData.gross + pricingData.discount)}</div>
            ) : null}
            <div className="actual-price">£{pricingData.gross}</div>
          </div>
        ) : (
          <span />
        )}
        {renderPitchNumbersCount()}
      </div>
      {onBookNow ? (
        <Button className="book-unit-button" onClick={bookByType}>
          Book
        </Button>
      ) : null}
    </div>
  )
}
